<!-- eslint-disable indent -->
<template>
    <div class="body">
      <div>
          <div>
            <label class="label-search">Etapa de Servico</label>
            <b-form-select  v-model="formAddServiceStage.etapa" class="form-control mb-3">
                <b-form-select-option :value="null">Selecione</b-form-select-option>
                <b-form-select-option
                    v-for="option in dataEtapaServico"
                    :key="option.id"
                    :value="option"
                    v-b-tooltip.hover :title="option.descricao"
                    class="custom-select-option"
                >
                     {{ option.descricao.length > 40 ? option.descricao.slice(0, 40) + '...' : option.descricao }}
                </b-form-select-option>
                </b-form-select>
          </div>
      </div>

      <div class="d-flex container_cancel_save">
          <div class="cancelar">
              <button class="button-cancel" @click="cancel">CANCELAR</button>
          </div>
          <div class="criar">
              <button class="button-save" @click="SalvaEtapaServico">ADICIONAR</button>
          </div>
      </div>
    </div>

  </template>

<script>
import addServiceStage from './addServiceStage'
export default addServiceStage
</script>

    <style scoped>
    .label-search{
      font-family: 'Segoe UI';
      font-size: 14px;
      font-weight: bold;
      color: rgb(141, 141, 141);
    }
     .margin {
      margin-top: 1rem;
     }
    .body{
      width: 100%;
      padding: 1rem;
    }
    .nome-epi{
      color: rgb(116, 116, 116);
      font-size: 13px;
      font-family: 'Segoe UI';
    }
   .descricaoArea{
      width: 100%;
      height: 5rem;
      border-color: #b3b3b3;
      border-radius: 1px;
   }

   .container_cancel_save{
    justify-content: center;
    width: 100%;
    margin-top: 1.5rem;
    column-gap: 20px;
   }

   .button-cancel{
     background-color: #b60000;
     color: white;
   }
   .button-save{
    background-color: #046437;
    color: white;
   }

  .button-cancel,
  .button-save{
    margin-top: 10;
    font-size: 12PX;
    outline: transparent;
    border: transparent;
    border-radius: 4px;
    text-transform: uppercase;
    width: 190px;
    height: 40px;
  }

  </style>



// WEBPACK FOOTER //
// src/views/private/apr/templateApr/components/addServiceStage/addServiceStage.vue